'use client';

import { Trans } from '@lingui/macro';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { List, ListItem, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Button } from '@prismo-io/design-system';
import { useRouter } from '@prismo-io/router';
import { usePathname } from 'next/navigation';
import type { FC } from 'react';
import { useSWRConfig } from 'swr';
import { useDeleteExperience } from '../../../hooks/use-delete-experience';
import { SkeletonItems } from '../skeleton-item';
import { useExperiencesSidebar } from './use-experiences-sidebar';
export const SidebarExperienceList: FC = () => {
  const {
    data: experiences = [],
    isLoading
  } = useExperiencesSidebar();
  const router = useRouter();
  const pathname = usePathname();
  const {
    mutate
  } = useSWRConfig();
  const onClick = (id: string | null) => {
    if (!id) {
      router.replace(pathname);
      return;
    }
    const query = `?id=${id}`;
    router.replace(pathname + query);
  };
  const {
    trigger: deleteExperience
  } = useDeleteExperience();
  const onDeleteItem = (id: string) => {
    deleteExperience(id, {
      onSuccess: async () => {
        router.replace(pathname);
        mutate('experience-quark-sidebar');
      }
    });
  };
  return <>
      <Stack component="header" direction="row" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap" padding={2} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        <Typography variant="h1" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Mes expériences ({experiences.length})</Trans>
        </Typography>
        <Button variant="outlined" onClick={() => onClick(null)} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">+ Ajouter</Trans>
        </Button>
      </Stack>
      <List data-sentry-element="List" data-sentry-source-file="index.tsx">
        {isLoading && <SkeletonItems />}
        {experiences.map(exp => {
        const name = exp.designation ? exp.designation.name : exp.custom_name;
        return <ListItem key={exp.id} disablePadding sx={{
          marginY: '0.25rem'
        }} secondaryAction={<IconButton edge="end" aria-label="delete" onClick={() => onDeleteItem(exp.id)}>
                  <DeleteOutline />
                </IconButton>}>
              <ListItemButton onClick={() => onClick(exp.id)}>
                <ListItemText primary={name} sx={{
              '& .MuiListItemText-primary': {
                fontWeight: 700,
                textDecoration: 'underline'
              }
            }} />
              </ListItemButton>
            </ListItem>;
      })}
      </List>
    </>;
};